<template>
   <div>
     <!-- <template slot="icon" >
      <div class="row-container">
        <img src="@/assets/logout-copy-2.svg" class="logout-copy-2" />
        <button class="export-button">Upload</button>
        <div class="showIntro" @click="goToIntro"><img src="@/assets/questionmark.png"></div>
      </div>
     </template> -->
     <crud-ctc></crud-ctc>
      <!-- <bottom-action-container v-if="showIntro">
        <btn-skip @navClicked="continuee"></btn-skip>
      </bottom-action-container> -->
      <bottom-action-container >
          <btn-skip @navClicked="continuee"></btn-skip>
          <template slot="end">
            <btn-grp>
              <btn text="Previous" type="secondary" @click="previous"/>
              <btn text="Next" type="primary" @click="continuee"/>
            </btn-grp>
          </template>
      </bottom-action-container>
</div>
</template>

<script>

// import CrudLevel from '../level/crud_levels.vue'
import CrudCtc from "./crud_CTC.vue"
export default {
  name: "Slabs",
  components: {
    CrudCtc
  },
  methods: {

    /* function to show intro */
    goToIntro() {
      this.$emit('displayIntro');
    },
  //below will be checked later 
    /* function to go back to previous page */
    previous() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/fbpConfigure`)
    },
    
    /* function to go to next page */
    continuee() {
     this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/fbpEligibility`)
    }
  }
}
</script>

<style>

</style>
